import {Directive, EventEmitter, Output} from "@angular/core";
import {EmptySearchParamsFilterModel} from "../../../shared/models/search/params/filters/empty-search-params-filter.model";
import {SearchResultsFilterModel} from "../../../shared/models/search/results/filters/search-results-filter.model";
import {SearchResultItemModel} from "../../../shared/models/search/results/items/search-result-item.model";
import {AbstractControl} from "@angular/forms";
import {ScopedSearchResultModel} from "../../models/search-results/scoped-search-result.model";

@Directive({
    selector: "[pcgNgTab]"
})
export class SearchTabDirective<TParamsFilter extends EmptySearchParamsFilterModel, TSearchResult extends ScopedSearchResultModel<SearchResultItemModel, SearchResultsFilterModel>> {
    private _filter: TParamsFilter;

    private _searchResult: TSearchResult;

    private _paginationControl: AbstractControl;

    public get filter(): TParamsFilter {
        return this._filter;
    }

    public set filter(value: TParamsFilter) {
        this._filter = value;
    }

    public get paginationControl(): AbstractControl {
        return this._paginationControl;
    }

    public set paginationControl(value: AbstractControl) {
        this._paginationControl = value;
    }

    public get searchResult(): TSearchResult {
        return this._searchResult;
    }

    public set searchResult(value: TSearchResult) {
        this._searchResult = value;
        this.searchResultsUpdated.emit(this.searchResult);
    }

    public get hasResult(): boolean {
        return Boolean(this.searchResult);
    }

    public get isEmptyResult(): boolean {
        return !this.searchResult.items || !this.searchResult.items.length;
    }

    @Output()
    public filterSubmitted: EventEmitter<TParamsFilter> = new EventEmitter<TParamsFilter>();

    @Output()
    public searchResultsUpdated: EventEmitter<TSearchResult> = new EventEmitter<TSearchResult>();

    public constructor() {
    }

    public showSuggestedWord(): boolean {
        const hasSearchResult = !!this.searchResult;
        if (!hasSearchResult) {
            return false;
        }

        const isEmptySearchResult = !this.searchResult.items.length;
        if (!isEmptySearchResult) {
            return false;
        }

        const hasSuggestedWord = !!this.searchResult.suggestedWord;
        if (!hasSuggestedWord) {
            return false;
        }

        return true;
    }
}
